import Trans from 'next-translate/Trans'
import React from 'react'

const NotAssigned = () => (

  <p style={{ margin: 'auto' }} className="ml-10 text-14 mb-10"><Trans i18nKey="transaction:notAssigned" /></p>
)

export default NotAssigned
